/**
 * Informazioni tecniche per le richieste di assistenza (doc 46).
 *
 * Tiene in memoria, solo in questa scheda del browser, gli ultimi errori: errori JavaScript,
 * chiamate alle API fallite (metodo, indirizzo senza parametri, codice) e le ultime pagine
 * visitate. Non salva niente da nessuna parte: parte solo se l'utente invia una richiesta di
 * assistenza lasciando spuntato "Allega informazioni tecniche", e prima vede cosa contiene.
 * Mai il contenuto delle risposte, mai i parametri delle ricerche (possono contenere nomi).
 */

const MAX = 15
const errori = []
const chiamate = []
const pagine = []

const adesso = () => new Date().toISOString()
const corto = (s, n = 300) => {
  const t = String(s || '')
  return t.length > n ? `${t.slice(0, n)}…` : t
}
const senzaParametri = url => String(url || '').split('?')[0]
const aggiungi = (lista, voce) => {
  lista.push(voce)
  if (lista.length > MAX) lista.shift()
}

let installata = false

export const installaDiagnostica = () => {
  if (installata || typeof window === 'undefined') return
  installata = true

  window.addEventListener('error', e => {
    aggiungi(errori, { quando: adesso(), tipo: 'errore', messaggio: corto(e.message), file: senzaParametri(e.filename), riga: e.lineno })
  })
  window.addEventListener('unhandledrejection', e => {
    const r = e.reason
    aggiungi(errori, { quando: adesso(), tipo: 'promessa', messaggio: corto(r && r.message ? r.message : r) })
  })
  const consoleError = window.console.error
  window.console.error = (...args) => {
    try {
      aggiungi(errori, {
        quando: adesso(),
        tipo: 'console',
        messaggio: corto(args.map(a => (a && a.message) || (typeof a === 'string' ? a : '')).join(' ')),
      })
    } catch (err) {
      // la diagnostica non deve mai rompere l'applicazione
    }
    consoleError.apply(window.console, args)
  }
  const segnaPagina = () => aggiungi(pagine, { quando: adesso(), pagina: senzaParametri(window.location.hash) })
  window.addEventListener('hashchange', segnaPagina)
  segnaPagina()
}

/** Registra le chiamate fallite di un client axios. */
export const registraAxios = client => {
  client.interceptors.response.use(
    r => r,
    error => {
      try {
        const c = (error && error.config) || {}
        aggiungi(chiamate, {
          quando: adesso(),
          metodo: String(c.method || '').toUpperCase(),
          indirizzo: senzaParametri(c.url),
          stato: error && error.response ? error.response.status : 'nessuna risposta',
        })
      } catch (e) {
        // ignorato
      }
      return Promise.reject(error)
    },
  )
}

/** Fotografia da allegare alla richiesta. */
export const raccogliDiagnostica = () => ({
  pagina: senzaParametri(window.location.href),
  quando: adesso(),
  browser: navigator.userAgent,
  lingua: navigator.language,
  schermo: `${window.screen.width}x${window.screen.height}`,
  finestra: `${window.innerWidth}x${window.innerHeight}`,
  versione: process.env.REACT_APP_VERSION || null,
  pagine_visitate: [...pagine],
  chiamate_fallite: [...chiamate],
  errori: [...errori],
})
